import API from '@aws-amplify/api';
import { t } from 'i18next';
import { toast } from 'react-toastify';

function useFileIO() {
    const UploadFile = async (fileData, docType) => {
        //API call to create file metadata within the database and receive an S3 url
        let s3Call;
        try {
            s3Call = await API.post('ShipyardAPI', '/file/create_metadata', {
                body: {
                    FileName: fileData?.name,
                    DocType: docType,
                    MimeType: fileData?.type,
                },
            });
        } catch (e) {
            toast.error(t('General.AjaxError'));

            return false;
        }

        //fetch() call here to the URL provided by the above API call
        let fetchCall;
        try {
            let options = {
                body: fileData,
                headers: {
                    'Content-Type': '',
                },
                method: 'PUT',
            };

            fetchCall = await fetch(s3Call.url, options);

            if (!fetchCall.ok) {
                toast.error(t('General.AjaxError'));

                return false;
            }
        } catch (e) {
            toast.error(t('General.AjaxError'));

            return false;
        }

        try {
            await API.post('ShipyardAPI', '/file/uploaded', {
                body: {
                    FileID: s3Call.fileId,
                    IsUploaded: 1,
                },
            });
        } catch (e) {
            toast.error(t('General.AjaxError'));

            return false;
        }

        return {
            name: fileData.name,
            fileId: s3Call.fileId,
            uploadedOn: new Date().toISOString(),
            type: fileData.type,
        };
    };

    return { UploadFile };
}

export default useFileIO;
